import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { useSearchParamsModal } from '../../../../../../components/modal/useSearchParamsModal';

import { Column } from '../../../../../../components/grid/Grid';
import { SearchModal } from '../../components/search-modal/SearchModal';
import { SearchQuerySectionDecisions } from '../../components/search-query-section/decisions/SearchQuerySectionDecisions';

import { LegislationContextType } from '../../../../legislation.types';

import { transformCount } from '../../utils/utils';

type Props = {
  decisions: LegislationContextType['decisions'];
  articleIds: string[];
  articleTitle: string;
  referencesDecisionsIds: string[];
  QPCDecisionsIds: string[];
  articleId: string;
  textNature: string;
  initialVersionId: string;
};

export const Decisions: FC<Props> = ({
  decisions,
  articleIds,
  articleTitle,
  referencesDecisionsIds,
  QPCDecisionsIds,
  articleId,
  textNature,
  initialVersionId,
}) => {
  useSearchParamsModal('decisions', (modalProps) => (
    <SearchModal
      restrictedIds={articleIds}
      title={articleTitle}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...modalProps}
    />
  ));

  return (
    <>
      <Column medium={4}>
        <h2>
          <FormattedMessage
            id="page/article/sections/Decisions.tsx/1"
            values={{ count: transformCount(decisions?.data?.totalHits ?? 0) }}
          />
        </h2>
      </Column>
      <Column medium={8}>
        {decisions?.data?.hits.length ? (
          <SearchQuerySectionDecisions
            articleIds={articleIds}
            decisions={decisions}
            referencesDecisionsIds={referencesDecisionsIds}
            QPCDecisionsIds={QPCDecisionsIds}
            articleId={articleId}
            articleTitle={articleTitle}
            textNature={textNature}
            initialVersionId={initialVersionId}
          />
        ) : (
          <p>
            <FormattedMessage id="page/article/sections/Decisions.tsx/2" />
          </p>
        )}
      </Column>
    </>
  );
};
